import { ActionMenu } from '@monorepo/shared/componentsV2/menus/ActionMenu';
import { DocumentFolderWithFileCountResponse } from 'mapistry-shared';
import React, { useState } from 'react';
import { useDocumentFoldersList } from '../../hooks/useDocumentFoldersList';
import { DeleteFolderModal } from './DeleteFolderModal';
import { FolderFormModal } from './FolderFormModal';

interface FoldersTableActionsProps {
  organizationId: string;
  folder: DocumentFolderWithFileCountResponse;
}

export function FoldersTableActions({
  organizationId,
  folder,
}: FoldersTableActionsProps) {
  const [isRenameOpen, setIsRenameOpen] = useState(false);
  const [isDeleteOpen, setIsDeleteOpen] = useState(false);

  const { documentFolders, isLoading } = useDocumentFoldersList({
    organizationId,
  });

  const options = [
    {
      displayName: 'Rename',
      onClick: () => setIsRenameOpen(true),
    },
    {
      displayName: 'Delete',
      onClick: () => setIsDeleteOpen(true),
    },
  ];

  if (isLoading || documentFolders === undefined) {
    return null;
  }

  return (
    <>
      <ActionMenu
        altText={`Action menu for ${folder.name} folder`}
        options={options}
      />
      {isRenameOpen && (
        <FolderFormModal
          organizationId={organizationId}
          documentFolders={documentFolders}
          folder={folder}
          onClose={() => setIsRenameOpen(false)}
        />
      )}
      {isDeleteOpen && (
        <DeleteFolderModal
          organizationId={organizationId}
          documentFolders={documentFolders}
          folder={folder}
          onClose={() => setIsDeleteOpen(false)}
        />
      )}
    </>
  );
}
